/** @format */

const questionsData = [
  {
    name: "Question 1",
    //   id: 1,
    text: "I am the answer 1",
  },
  {
    name: "Question 2",
    //   id: 2,
    text: "I am the answer 2",
  },
  {
    name: "Question 3",
    //   id: 3,
    text: "I am the answer 3",
  },
  {
    name: "Question 4",
    //   id: 4,
    text: "I am the answer 4",
  },
  {
    name: "Question 5",
    //   id: 5,
    text: "I am the answer 5",
  },
];

export default questionsData;
